import {GET_ALL_ATTENDANCE} from "../../constant/ActionType";

export default function AttendanceReducer(state = {
    attendanceData:[],
    statusCode: null,
}, action) {
    switch (action.type) {    
        case GET_ALL_ATTENDANCE:
			return { ...state,
				attendanceData: action?.data ,
                statusCode:action.status
            };

        default:
    }
    return state;
}


